import { Component, OnInit, OnDestroy } from '@angular/core';
import { DesignSystemSigmaService } from 'app/services/design-system-sigma.service';

@Component({
    selector: 'app-content-layout',
    templateUrl: './content-layout.component.html',
    styleUrls: ['./content-layout.component.scss']
})
export class ContentLayoutComponent implements OnInit, OnDestroy {

  constructor(private dssService: DesignSystemSigmaService) {}

  public ngOnInit(): void {
    this.dssService.applyTheme();
  }

  public ngOnDestroy(): void {}

}
